var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode-wrap"},[_c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":_vm.qrImageData,"alt":"二维码"}})]),_c('p',[_vm._v("长按二维码识别详情")])])}
var staticRenderFns = []

export { render, staticRenderFns }